import { render, staticRenderFns } from "./WorkFilterWidget.vue?vue&type=template&id=60f18afe&scoped=true&"
import script from "./WorkFilterWidget.vue?vue&type=script&lang=js&"
export * from "./WorkFilterWidget.vue?vue&type=script&lang=js&"
import style0 from "./WorkFilterWidget.vue?vue&type=style&index=0&id=60f18afe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f18afe",
  null
  
)

/* custom blocks */
import block0 from "./WorkFilterWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDialog,VIcon,VTooltip})
